<template>
  <div class="card" style="max-width:340px;margin:10px;">
    <h5 class="card-title">Kante</h5>
    <div class="btn-toolbar" role="toolbar">
      <button @click="updateData" class="btn btn-sm btn-primary">Update</button>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label>Bedingung</label>
        <input type="text" class="form-control" v-model="edge.cond"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BFlowEdgeProps',
  props: ["edge"],
  methods: {
    updateData() {
      console.log('update edge');
      this.$emit('update');
    }
  }
}
</script>
